import {
  CardInfo,
  GroupElementGrid,
  PreverAngelusFillMediumIcon,
  ProductClubeFillMediumIcon,
  ProductHealthFillMediumIcon,
  ProductPosthumousFillMediumIcon,
  Section,
  TitleAndDescription,
  token,
} from '@ferreri/prever-component-lib';

export const AboutAngeplusPlatform = () => {
  return (
    <Section>
      <TitleAndDescription
        title="Plataforma Angeplus"
        description="Adquira seu plano agora e tenha acesso ao Angeplus: a plataforma que traduz benefícios em soluções práticas para o seu dia a dia. Veja um resumo do que você tem no Angeplus:"
      />
      <GroupElementGrid>
        {products.map((product, index) => {
          return (
            <CardInfo key={index} title={product.title} icon={product.icon}>
              {product.description}
            </CardInfo>
          );
        })}
      </GroupElementGrid>
    </Section>
  );
};

const products = [
  {
    title: 'Meu plano',
    description:
      'Autonomia para, a qualquer momento, consultar e gerir seu plano (mensalidades, carteirinha e muito mais).',
    icon: <PreverAngelusFillMediumIcon />,
  },
  {
    title: 'Clube de vantagens',
    description:
      'Um clube com descontos exclusivos em produtos e serviços de grandes marcas e parceiros locais.',
    icon: (
      <ProductClubeFillMediumIcon color={token.colors.solidClubePrimaryPure} />
    ),
  },
  {
    title: 'Cuidado e saúde',
    description:
      'Praticidade e descontos especiais na área da saúde para o associado.',
    icon: (
      <ProductHealthFillMediumIcon color={token.colors.solidSaudePrimaryPure} />
    ),
  },
  {
    title: 'Serviços funerários',
    description:
      'Excelência e humanização no atendimento funeral com cobertura completa.',
    icon: (
      <ProductPosthumousFillMediumIcon
        color={token.colors.solidPostumosPrimaryPure}
      />
    ),
  },
];
